import type { ClosedDayBookingRequest, ClosedDayBookingResponse } from '../api/generated';
import { CLOSED_DAY_BOOKING_TYPE } from '../components/ClosedDayBookings/closedDayBookingConstants';
import { useBookings } from './useBookings';
import type { UseBookingsResult } from './useBookings';

export type UseClosedDayBookingsResult = UseBookingsResult<
  ClosedDayBookingRequest,
  ClosedDayBookingResponse
>;

export function useClosedDayBookings(locationId: string | null): UseClosedDayBookingsResult {
  return useBookings<ClosedDayBookingRequest, ClosedDayBookingResponse>(
    CLOSED_DAY_BOOKING_TYPE,
    locationId
  );
}
